export default "__VITE_ASSET__BW3N8cvn__"